import Button from "@components/common/Button";

const CustomerCard = ({ customer, isPermitted, handlehandleRequestVoucher }) => {
	return (
		<div className="group overflow-hidden rounded-md border border-blue-gray bg-dark-blue/80 transition-all duration-300 hover:border-[#7A82D8] hover:shadow-[0_8px_24px_rgba(126,125,216,.15)] active:scale-[0.99]">
			<div className="overflow-hidden">
				<img
					src={customer.photo}
					alt={customer.title}
					className="h-auto w-full transition-transform duration-500 group-hover:scale-105 md:h-full md:min-h-[100px]"
				/>
			</div>

			{/* Content */}
			<div className="flex flex-col p-4 text-start">
				<h3 className="font-bold text-sm text-white uppercase tracking-widest">{customer.title}</h3>

				{customer.description && (
					<p className="mt-2 text-[11px] text-gray-300 leading-6">{customer.description}</p>
				)}

				{customer.features && (
					<div className="mt-2">
						{customer.features.map((feature) => (
							<div key={feature.label}>
								<h4 className="mt-1 font-semibold text-[11px] text-white">{feature.label}</h4>

								<p className="mt-1 text-[11px] text-gray-300 leading-6">{feature.text}</p>
							</div>
						))}
					</div>
				)}

				{customer.extra && (
					<p className="mt-2 text-[11px] text-gray-300 leading-6">{customer.extra}</p>
				)}

				{customer.bullets && (
					<ul className="list-disc pl-5 text-[11px] text-gray-300 leading-6">
						{customer.bullets.map((bullet) => (
							<li key={bullet}>{bullet}</li>
						))}
					</ul>
				)}

				{customer.cta && isPermitted && (
					<div className="mt-3">
						<Button
							text={customer.cta}
							className={"!px-4 !py-2 !text-xs !font-semibold !text-white !me-2 w-full lg:w-auto"}
							type="button"
							onClick={handlehandleRequestVoucher}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default CustomerCard;
